import { formatUnits, parseEther } from '@ethersproject/units';
import { useEffect, useMemo, useState } from 'react';
import Detail from '../../../../../components/Detail';
import InfoPopUp from '../../../../../components/InfoPopUp';
import { formatUSD } from '../../../../../helpers/formats';
import useClaimableStakingRewards from '../../../../../hooks/web3/vault/useClaimableStakingRewards';
import useTotalAccumulatedVoSpool from '../../../../../hooks/web3/vault/useTotalAccumulatedVoSpool';

const VoSpoolEmissionRewards = () => {
    const { claimableStakingRewards } = useClaimableStakingRewards();
    const { totalAccumulatedVoSpool } = useTotalAccumulatedVoSpool();

    const [apy, setApy] = useState('0');

    const rewardPerTranche = useMemo(() => parseEther('57000'), []);

    const rewardPerYear = useMemo(
        () => rewardPerTranche.mul(365).div(7),
        [rewardPerTranche]
    );

    useEffect(() => {
        if (!totalAccumulatedVoSpool || !rewardPerYear) return;

        setApy(
            formatUnits(
                rewardPerYear.mul(10000).div(parseEther(totalAccumulatedVoSpool)),
                2
            )
        );
    }, [totalAccumulatedVoSpool, rewardPerYear]);

    return (
        <Detail
            title={
                <>
                    <span>Your voSPOOL Epoch Rewards ({apy}% APY)</span>
                    <InfoPopUp>
                        voSPOOL Epoch Rewards are emitted once per week at the beginning
                        of each weekly epoch.
                    </InfoPopUp>
                </>
            }
            value={
                <>
                    {claimableStakingRewards &&
                    Object.keys(claimableStakingRewards).length
                        ? formatUSD(claimableStakingRewards.voSpoolRewards['SPOOL'] || 0)
                        : '0.00'}{' '}
                    $SPOOL
                </>
            }
        />
    );
};

export default VoSpoolEmissionRewards;
